import { OutlineWarning01Icon } from '@tempmee/react-icons';
import { colors } from '@tempmee/tailwind';
import ConfirmPopup from '../../shared/ConfirmPopup';

/**
 * "Candidate Not Confirmed" guard shown when the office tries to leave the
 * confirm screen while top candidates are still available.
 */
export const ConfirmExitPopup = ({ onGoBack, onLeave }) => (
  <ConfirmPopup
    Icon={() => <OutlineWarning01Icon size={80} color={colors.warning[500]} />}
    leftButtonAction={onGoBack}
    leftButtonText="Go Back"
    rightButtonAction={onLeave}
    rightButtonText="Leave Anyway"
    title="Candidate Not Confirmed"
    titleStyle={{ marginBottom: 20, marginTop: 20 }}
    descriptionStyle={{ marginBottom: 40 }}
    description="Are you sure you want to leave without confirming someone? Your top candidates are still available but they could get hired by another office at any moment."
  />
);
